// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import productDescriptionVariantStyles from "@tps/App/SharedStyles/ProductDescriptionStyles";
import { productInformationStyles } from "@tps/Overrides/Widgets/ProductList/ProductListProductInformation";
import { css } from "styled-components";

productInformationStyles.container = {
    gap: 5,
    css: css`
        flex: 1;
        padding-left: 12px;
    `,
};

productInformationStyles.descriptionStyles = {
    ...productDescriptionVariantStyles.small,
};

productInformationStyles.boostScoreGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productInformationStyles.boostScoreTypography = {
    size: 14,
    lineHeight: "19px",
};
productInformationStyles.ootbBoostScoreGridItem = {
    width: 12,
    css: css`
        padding-top: 8px;
        > dl {
            width: 100%;
        }
        &:empty {
            display: none;
        }
    `,
};
